import React, { useState } from 'react'
import './Navbar.scss';
import { images } from '../../constants';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { easeInOut, motion } from 'framer-motion'

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setToggle(false); // Close the menu if it's open
  };

  return (
    <nav className='app_navbar'> {/*BEM METHOD*/}
      <div className='app_navbar-logo' onClick={scrollToTop}>
        <img src={images.logo} alt="logo" />
      </div>
      <ul className='app_navbar-links'>
        {['Home', 'About', 'Work', 'Skills', 'Contact'].map((item) => (
          <li className='app_flex p-text' key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className='app_navbar-menu'>
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {toggle && (
          <motion.div
            whileInView={{ x: [250, 0] }}
            transition={{ duration: 0.85, ease: easeInOut }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {['Home', 'About', 'Work', 'Skills', 'Contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                </li>
              ))}
            </ul>
            <a
              href="/Kaushal_CV.pdf"
              download
              className="app_navbar-download-btn"
              onClick={() => setToggle(false)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </a>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
